import React, { useContext } from 'react'
import { ButtonContainer, Wrapper } from './LotOutsideDates.style'
import Icon from '../../../../components/style/Icon.style'
import { Trans, useTranslation } from 'react-i18next'
import Text from '../../../../components/style/Text.style'
import { useStyletron } from 'parkdepot-shared/theme'
import Button from 'parkdepot-shared/components/Buttons/Button'
import { BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons/types'
import { LotContext } from '../../../../context/LotContext/lot.context'
import { DateTime } from 'luxon'
import { useHistory } from 'react-router-dom'
import { homeRoute } from '../../../Home/route.const'

const LotOutsideDates = () => {
    const { t } = useTranslation()
    const [css, theme] = useStyletron()
    const history = useHistory()

    const { lot } = useContext(LotContext)

    const onHomeClick = () => {
        history.push(homeRoute())
    }

    return (
        <Wrapper>
            <Icon $size="large" className="wemolo-wemolon" color={theme.colors.primary} aria-hidden="true" />
            <Text
                className={css({
                    marginTop: '12px'
                })}
                typography={theme.typography.HeadingLarge}
                fontWeight={700}
                $align="center"
            >
                {t('lot.closedLot')}
            </Text>
            <Text $align="center" typography={theme.typography.ParagraphMedium} fontWeight={300}>
                <Trans i18nKey="lot.openingLotDays">
                    {{
                        start: DateTime.fromFormat(lot?.earliest_booking_date || '', 'yyyy-MM-dd').toFormat(
                            'dd.MM.yyyy'
                        )
                    }}
                    {{ end: DateTime.fromFormat(lot?.end_of_live_date || '', 'yyyy-MM-dd').toFormat('dd.MM.yyyy') }}
                </Trans>
            </Text>
            <ButtonContainer>
                <Button
                    id="back-to-home-btn"
                    $size={BUTTON_SIZE.medium}
                    $kind={BUTTON_KIND.primary}
                    onClick={onHomeClick}
                >
                    {t('lot.back')}
                </Button>
            </ButtonContainer>
        </Wrapper>
    )
}

export default LotOutsideDates
